<template>
  <div>
    <v-filter-brands
      v-for="(value, key, index) in FilterData"
      v-if="key === 'Brands'"
      :key="value.Value"
      v-model="selectedFilters[filters[index].value]"
      :selectedFilters="selectedFilters"
      :items="value"
      :filter-name="filters[index].name"
      :width="filters[index].width"
      :allowMultiple="filters[index].allowMultiple"
      @change="filterChange"
      @product-change="filterChange"
      item-name="DisplayValue"
      item-value="Value">
    </v-filter-brands>

    <v-loading :data="loaded"></v-loading>

    <div class="o-wrapper o-wrapper--center content u-margin-top" :style="selectedFilters['Brands'] === null ? 'filter: blur(4px); pointer-events: none;' : ''">
      <v-filters v-if="FilterData && dataFilter" custom-class="o-page-row--medium" theme="side"
                 :selectedFilters="selectedFilters" :filters="filters">
        <v-filter-checkbox-product
          v-for="(value, key, index) in FilterData"
          v-if="key !== 'Brands'"
          :key="value.Value"
          v-model="selectedFilters[filters[index].value]"
          :items="value"
          :filter-name="filters[index].name"
          :allowMultiple="filters[index].allowMultiple"
          @change="filterChange"
          item-name="DisplayValue"
          item-value="Value"
          :openOnLoad="filters[index].openOnLoad">
        </v-filter-checkbox-product>
      </v-filters>

      <div class="products">

        <!-- PAGINATION-->
        <v-pagination
          v-if="dataPagination"
          class="c-pager o-page-row line"
          :config="paginationConfig"
          :pagination="Pagination"
          @paginated="fetchProductData">

          <div slot="page-size" class="[ c-select c-form-item ] custom-select u-flex u-flex--align-items-center">
            <div class="u-pos-relative u-margin-right-tiny">
              <select v-model="pageSize" @change="fetchPageSize" id="pageSize" name="pageSize"
                      class="[ c-select-element c-form-element ]">
                <option v-for="option in pageSizeOptions" :key="option.value" :value="option.value">{{
                    option.content
                  }}
                </option>
              </select>
              <div class="c-select-icon">
                <svgicon class="svg-down" name="arrow-rounded" width="5.5" height="5"></svgicon>
              </div>
            </div>
            <label for="pageSize" class="u-color-muted">{{ $t('product_overview.filters.page_size') }}</label>
          </div>
        </v-pagination>

        <!-- GRID BLOCKS -->
        <div class="c-shop-overview u-margin-bottom-medium">
          <component v-for="(value, key, index) in GridData" :key="key" :is="dynamicComponent" :item="value"
                     v-if="value" :stockOnly="selectedFilters['StockOnly'] !== null ? selectedFilters['StockOnly'][0].Value === 'true' : null"></component>
        </div>

        <v-pagination
          v-if="dataPagination"
          class="c-pager o-page-row"
          :config="paginationConfig"
          :pagination="Pagination"
          :pageInfo="false"
          @paginated="fetchProductData">
        </v-pagination>
      </div>
    </div>

  </div>
</template>


<script>
import VLoading from '@/components/Loading'
import VInput from '@/components/form/Input'
import VSelect from '@/components/form/Select'
import VCustomSelect from '@/components/form/CustomSelect'
import VFilters from '@/components/form/filters/Filters'
import VPagination from '@/components/Pagination'
import VProductThumb from '@/components/shop/ProductThumb'
import _isEmpty from 'lodash/isEmpty'

export default {
  components: {
    VLoading,
    VInput,
    VSelect,
    VCustomSelect,
    VFilters,
    VPagination,
  },
  props: {
    dataFilterTable: String,
    dataTable: String,
    dataFilter: String,
    dataPagination: String,
    filters: {type: [Array, Boolean]},
    gridElement: String,
  },
  data() {
    return {
      paginationConfig: {
        Page: 1
      },
      selectedFilters: {},
      pageSize: 12,
      addBranchFilter: true,
      pageSizeOptions: [
        {value: 12, content: 12},
        {value: 24, content: 24},
        {value: 48, content: 48},
        {value: 96, content: 96}
      ],
      loaded: {}
    }
  },
  created() {
    if (!this.$route.query.pageSize) {
      this.$route.query.pageSize = this.pageSize;
    }
    this.setFilters();
    this.initialDatafetch();
  },
  mounted() {
    if (this.$route.query.addBranchFilter !== 'undefined') {
      this.addBranchFilter = this.$route.query.addBranchFilter;
    }
  },
  computed: {
    dynamicComponent() {
      return VProductThumb;
    },
    GridData() {
      return this.$store.getters[this.dataTable]
    },
    FilterData() {
      if (!this.dataFilter) {
        return
      }
      let output = {};
      let data = this.$store.getters[this.dataFilter];

      // Only get filters from props
      this.filters.forEach((filter) => {
        if (data[filter.single]) {
          this.$set(output, [filter.single], data[filter.single]);
        }
      });

      return _isEmpty(data) ? null : output;
    },
    Pagination() {
      return this.$store.getters[this.dataPagination]
    },
    urlFilters() {
      if (!this.dataFilter) {
        return
      }
      let params = {};
      params.Page = this.paginationConfig.Page;
      params.pageSize = this.pageSize;
      params.addBranchFilter = this.addBranchFilter;

      this.filters.forEach((filter) => {
        params[filter.value] = this.createUrlParams(filter.value.toString());
      })

      return params;
    }
  },
  methods: {
    setFilters() {
      if (this.dataFilter) {
        this.filters.forEach((filter) => {
          this.$set(this.selectedFilters, [filter.value], null);

          if (this.$route.query.hasOwnProperty(filter.value)) {
            if (this.$route.query[filter.value]) {
              let values = this.$route.query[filter.value].split(',').map(x => {
                return {'DisplayValue': x, 'Value': x, 'IsSelected': true}
              });
              this.$set(this.selectedFilters, [filter.value], values);
            }
          }
        });
      }

      if (this.$route.query.Page) {
        this.paginationConfig.Page = parseInt(this.$route.query.Page);
      }

      if (this.$route.query.pageSize) {
        this.pageSize = this.$route.query.pageSize;
      }

      if (this.$route.query.addBranchFilter !== 'undefined') {
        this.addBranchFilter = this.$route.query.addBranchFilter;
      }
    },
    // Initial fetch
    initialDatafetch() {
      let query = {};
      if (this.prefix && Object.keys(this.$route.query).includes(this.prefix + 'Page')) {
        Object.keys(this.$route.query).forEach((key) => {
          this.$set(query, [key.replace(this.prefix, "")], this.$route.query[key]);
        });
      } else {
        query = this.$route.query
      }

      this.dispatchGridData(query, true);
    },
    filterChange() {
      this.paginationConfig.Page = 1;
      this.fetchProductData();
    },
    // Fetch all data
    fetchProductData() {
      this.loaded = {};
      let params = this.urlFilters;

      this.dispatchGridData({
        Page: this.paginationConfig.Page,
        pageSize: this.pageSize,
        ...params
      });
    },
    fetchFilterData() {
      this.loaded = {}
      let params = this.urlFilters;
      this.dispatchFilterData({
        ...params
      })
    },
    dispatchGridData(params, initialFetch) {
      if (initialFetch) {
        this.$store.dispatch(('get' + this.dataTable).toString(), {
          params: {
            ...params
          }
        }).then(() => {
          this.loaded = {isLoaded: true};
        }).catch(() => {
          this.loaded = {isLoaded: true};
        });
      } else {
        if (this.dataFilter) {
          this.setRouterParams(params);
        }
      }
      sessionStorage.setItem('customerFilters', window.location.search);
    },
    dispatchFilterData(params) {
      this.$store.dispatch("getProductAggregations", {
        params: {
          ...params
        }
      }).then(() => {
        this.loaded = {isLoaded: true};
      }).catch(() => {
        this.loaded = {isLoaded: true};
      })
    },
    // Push params to browser address bar
    setRouterParams(params) {
      let query = {};
      let urlQuery = this.$route.query;

      // Return on empty params
      if (Object.keys(params).length === 0 && params.constructor === Object) {
        return;
      }

      // Check for prefix and when there is no prefix in query
      if (this.prefix) {
        Object.keys(params).forEach((key) => {
          // Don't use prefix if prefix exists
          if (Object.keys(urlQuery).includes((key))) {
            this.$set(query, key, params[key]);
          }
          // Use prefix for new values
          else {
            this.$set(query, (this.prefix + key), params[key]);
          }
        });
      } else {
        query = params;
      }

      // Merge values
      query = Object.assign({}, urlQuery, query);
      query.defaultPreOnly = false;

      // Push to router
      this.$router.push({
        path: this.$route.path,
        query: {...query}
      });
    },

    // Convert object to comma separated values for ajax call
    createUrlParams(name) {
      if (this.selectedFilters[name] && this.selectedFilters[name].length) {
        return this.selectedFilters[name].map(item => {
          return item.Value
        }).join();
      } else {
        return undefined;
      }
    },
    fetchPageSize() {
      this.loaded = {};
      this.$route.query.Page = 1
      this.setRouterParams({
        pageSize: this.pageSize
      });
      this.initialDatafetch();
    }
  }
}
</script>

<style lang="scss">
@import "~@/assets/scss/private";
@import "~fg-select-css/src/select-css";
@import "~fg-select-css/src/select-css-compat";

$iconWidth: em($global-spacing-unit);

.content {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  column-gap: em($global-spacing-unit);
}

.products {
  grid-column: span 3 / span 3;
}

.line {
  border-bottom: 1px solid rgba($color-base, .2);
}

.c-shop-overview {
  display: flex;
  flex-wrap: wrap;

  > * {
    max-width: 25%;
    padding-right: 30px;
    margin-bottom: 30px;
    flex: 0 0 (100%/4);

    @include down($desktop) {
      max-width: 50%;
      flex: 0 0 50%;
    }
  }

  @supports (display: grid) {
    display: grid;
    grid-gap: 30px;
    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
    > * {
      max-width: initial;
      padding-right: initial;
      margin-bottom: initial;
    }
  }
}

.c-select {
  background-color: white;
  border: none;

  &--fluid {
    display: flex;
  }

  .c-select-element {
    border-radius: 0;
    font: inherit;
    $padding: em($global-spacing-unit-tiny*1.85);
    line-height: 18px;
    vertical-align: top;
    padding: $padding em($global-spacing-unit-tiny*1.5);
    padding-right: $padding + $iconWidth;
    border: none;
    box-shadow: inset 0 0 0 1px rgba($color-base, .2);

    &:focus {
      border-color: transparent;
    }
  }
}

.c-select-icon {
  position: absolute;
  right: 0;
  top: 0;
  height: 100%;
  width: $iconWidth;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;

  svg {
    fill: $color-alpha;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/OverviewGrid.vue